import { render, staticRenderFns } from "./DashboardTemplate.vue?vue&type=template&id=bf4bb0f8&scoped=true"
import script from "./DashboardTemplate.vue?vue&type=script&lang=js"
export * from "./DashboardTemplate.vue?vue&type=script&lang=js"
import style0 from "./DashboardTemplate.vue?vue&type=style&index=0&id=bf4bb0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4bb0f8",
  null
  
)

export default component.exports